import { useQuery } from '@tanstack/react-query';
import { DynamicUiEntityLayout } from 'src/UI/dynamicUI/types';

export default function useFinancialEntityLayout({ entityType }: { entityType?: string } = {}) {
  const { data, isLoading, isError, refetch } = useQuery<DynamicUiEntityLayout>({
    queryKey: ['entities', 'financial-layout-bff', entityType],
    enabled: !!entityType,
  });

  return {
    layout: data ?? undefined,
    isLoading,
    isError,
    refetch,
  };
}
